import CustomRangeInput from '../components/atoms/scrollBar/ScrollBar';
import React, { useEffect, useRef, useState } from 'react';

const ScrollerRenderProp = ({
  children,
  isExist,
  isWide,
  customClasses,
  sizeGuide,
  newSizeGuide,
}) => {
  const [newValue, setNewValue] = useState(0);
  const [isScrollShow, setScrollShow] = useState(!isWide);

  const blockRef = useRef(null);
  const inputRef = useRef(null);
  const countRef = useRef(0);

  useEffect(() => {
    setNewValue(0);
    blockRef.current.scrollLeft = 0;
  }, [children]);

  useEffect(() => {
    countRef.current = 0;
  }, [sizeGuide, newSizeGuide]);

  useEffect(() => {
    const showScrollOnResize = () => {
      setScrollShow(
        blockRef?.current?.scrollWidth > blockRef?.current?.clientWidth,
      );
    };
    setTimeout(() => {
      showScrollOnResize();
    }, 100);
    window.addEventListener('resize', () => {
      showScrollOnResize();
    });
    return () => {
      setNewValue(0);
      window.removeEventListener('resize', showScrollOnResize);
    };
  }, []);

  const calclulateInputValue = () => {
    const fullWidth = blockRef?.current?.scrollWidth;
    const visibleWidth = blockRef?.current?.clientWidth;
    const offset = blockRef?.current?.scrollLeft;
    const notVisibleWidth = fullWidth - visibleWidth;
    return (offset * 100) / notVisibleWidth;
  };

  const positionValuesArr = [
    { percent: 0, position: 0 },
    {
      percent: 50,
      position:
        (blockRef?.current?.scrollWidth - blockRef?.current?.clientWidth) / 2,
    },
    {
      percent: 100,
      position: blockRef?.current?.scrollWidth - blockRef?.current?.clientWidth,
    },
  ];

  const calculatePosition = (fixedValue, countV) => {
    // Using ref to minify state rerender
    if (fixedValue >= 0 && fixedValue < 50 && countV === 'inc')
      countRef.current = 0;
    if (fixedValue > 0 && fixedValue < 50 && countV === 'decr')
      countRef.current = 1;
    if (fixedValue >= 50 && fixedValue < 100 && countV === 'inc')
      countRef.current = 1;
    if (fixedValue >= 50 && fixedValue < 100 && countV === 'decr')
      countRef.current = 2;
    if (fixedValue === 50 && fixedValue < 100 && countV === 'decr')
      countRef.current = 1;
    if (fixedValue > 50 && fixedValue <= 100 && countV === 'decr')
      countRef.current = 2;
  };

  const scrollTo = (countV) => {
    const fixedValue = Math.ceil(newValue);

    calculatePosition(fixedValue, countV);

    if (countV === 'inc') {
      countRef.current += 1;
      setNewValue(positionValuesArr[countRef.current].percent);
      blockRef.current.scrollLeft =
        positionValuesArr[countRef.current].position;
    } else {
      countRef.current -= 1;
      setNewValue(positionValuesArr[countRef.current].percent);
      blockRef.current.scrollLeft =
        positionValuesArr[countRef.current].position;
    }
  };

  return (
    <div
      onWheel={(e) => {
        if (!isExist) return;
        if (!isScrollShow) return;

        blockRef.current.scrollLeft += e.deltaY > 0 ? 30 : -30;
        setNewValue(Math.round(calclulateInputValue()));
      }}
      onScroll={() => setNewValue(Math.round(calclulateInputValue()))}
    >
      {children({
        blockRef,
        scrollTo,
        isScrollShow,
        percentageOfScroll: newValue,
      })}
      {isExist && isScrollShow && (
        <CustomRangeInput
          ref={inputRef}
          blockRef={blockRef}
          newValue={newValue}
          setNewValue={setNewValue}
          customClasses={customClasses}
        />
      )}
    </div>
  );
};

export default ScrollerRenderProp;
